module.exports = __webpack_public_path__ + "static/media/reglages.372e2d1b.png";